export default "__VITE_ASSET__DmUhBLTS__"